import * as React from 'react';

import { LinearProgress } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

export default function HorizontalProgressBar({ height, value }){   

    const BorderLinearProgress = withStyles((theme) => ({
        root: {
          height: height,
          borderRadius: 10,
        },
        colorPrimary: {
          backgroundColor: '#e7e8e8',
        },
        bar: {
          borderRadius: 10,
          backgroundColor: '#108c0c',
        },
      }))(LinearProgress);

    return (
        <>
            <BorderLinearProgress variant="determinate" value={value} />
        </>
    );
}